import { useLayoutEffect } from "react";

/**
 * Hook to reset scroll position to top when component mounts
 * Ensures pages always start from the top regardless of previous scroll position
 */
export const useScrollReset = () => {
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);
};
